import * as React from "react";
import ProjectDetails from "./ProjectDetails";
const galleryImages = [{
  id: 1,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/IMG_20211104_152631-scaled.jpg?v=1r5hhquk8yy",
  alt: "Pareklisia residence exterior view"
}, {
  id: 2,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/IMG_20211104_152657-scaled.jpg?v=mc3wgesnond",
  alt: "Interior living room renovation"
}, {
  id: 3,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/IMG_20211104_152732-scaled.jpg?v=8xofpdut1ym",
  alt: "Modern kitchen remodel"
}, {
  id: 4,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/IMG_20211104_152927-scaled.jpg?v=oy4wlz8q8sm",
  alt: "Master bedroom interior design"
}, {
  id: 5,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/IMG_20211104_153150-scaled.jpg?v=nqj38y09ana",
  alt: "Luxury bathroom renovation"
}, {
  id: 6,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/IMG_20211104_153326-scaled.jpg?v=0guc4ke1tsj",
  alt: "Outdoor terrace and garden"
}];
export default function ProjectHeroImage() {
  return <section id="project-hero-image" className="bg-[#fff] py-12">
      <div className="w-full px-8 max-w-[1920px] mx-auto">
        <h1 className="text-center font-bold mb-10 !text-[27px]">Agios Nikolaos Full House Renovation</h1>
           <ProjectDetails />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image, i) => <div key={image.id} data-index={i} className="overflow-hidden rounded-[0.5rem] bg-muted/20">
              <img src={image.src} alt={image.alt} className="w-full h-full object-cover aspect-[4/3] transition-transform duration-500 hover:scale-105" loading={i < 3 ? "eager" : "lazy"} />
            </div>)}
        </div>
      </div>
    </section>;
}